import { kColors } from "./kColors";

// refer to these as constants not as STYLES
// That makes a lot more sense
// removed the custom font for now because
// body is being used everywhere and the design has yet to be approved
// Type ahead is not working for kFonts?
// errors are not being caught for kFonts
//Possible solution? maybe use a validator:

export const kFonts = {
  title: {
    fontSize: 22,
  },
  H3: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: 16,
  },
  body: {
    fontFamily: "Poppins",
    fontWeight: "300",
    fontSize: 14,
    letterSpacing: 1,
  },
  bodySmall: {
    fontSize: 9,
    fontFamily: "Poppins",
    fontWeight: "300",
  },
  bodySmallCenter: {
    fontSize: 10,
    fontFamily: "Poppins",
    fontWeight: "300",
    letterSpacing: 0.2,
  },
  bodyItalic: {
    fontSize: 12,
    fontStyle: "italic",
  },
  bodyItalicBold: {
    fontSize: 14,
    fontStyle: "italic",
    fontWeight: "bold",
  },
  bodyBold: {
    fontFamily: "Poppins",
    lineHeight: 20,
    fontSize: 14,
    fontWeight: "600",
  },
  bodyWhite: {
    color: kColors.white,
    fontSize: 14,
  },
  bodyBlackSemiBold: {
    fontSize: 14,
    fontWeight: "700",
  },
  bodyMedium: {
    fontSize: 14,
    fontWeight: "500",
  },
  bodyLight: {
    fontSize: 14,
    fontWeight: "300",
  },
  clickable: {
    fontSize: 16,
    textDecorationLine: "underline",
  },
  textFullWidth: {
    width: "100%",
  },
  textBold: {
    fontWeight: "500",
  },
  textUnderline: {
    textDecorationLine: "underline",
  },
  // marginHeader: {
  //   fontSize: 20,
  //   fontWeight: "bold",
  // },
  profileHeader: {
    fontSize: 22,
    fontWeight: "500",
  },
  formLegend: {
    fontSize: 14,
    fontWeight: "600",
    color: kColors.darkGray,
    letterSpacing: 1.2,
  },
  buttonText: {
    color: kColors.white,
    fontSize: 14,
    fontWeight: "600",
  },
  menuTitle: {
    fontSize: 16,
    fontFamily: "Poppins",
    fontWeight: "300",
  },
  // menuTitleBold: {
  //   fontSize: 16,
  //   fontFamily: "Poppins",
  //   fontWeight: "bold",
  // },
  pageTitle: {
    fontSize: 30,
    fontFamily: "Poppins",
    fontWeight: "300",
  },
  subHeader: {
    fontSize: 12,
    fontFamily: "Poppins",
    fontWeight: "500",
    letterSpacing: 0.75,
  },
  header: {
    fontSize: 22,
    fontFamily: "Poppins",
    fontWeight: "400",
  },
  facet: {
    fontSize: 16,
    fontFamily: "Poppins",
    fontWeight: "500",
  },
  facetSelected: {
    fontSize: 16,
    fontFamily: "Poppins",
    fontWeight: "700",
    letterSpacing: 0.1,
  },
  poppinsLight: {
    fontSize: 14,
    fontFamily: "Poppins",
    fontWeight: "300",
  },
  poppinsExtraSmallMedium: {
    fontSize: 10,
    fontFamily: "Poppins",
    fontWeight: "400",
  },
  poppinsLightSmall: {
    fontSize: 12,
    fontFamily: "Poppins",
    fontWeight: "300",
  },
  poppins400: {
    fontSize: 14,
    fontFamily: "Poppins",
    fontWeight: "400",
  },
  poppinsRegular: {
    fontSize: 14,
    fontFamily: "Poppins",
    fontWeight: "500",
  },
  poppinsRegularExtraLight: {
    fontSize: 14,
    fontFamily: "Poppins",
    fontWeight: "200",
  },
  poppinsRegularLight: {
    fontSize: 14,
    fontFamily: "Poppins",
    fontWeight: "300",
  },
  poppinsRegularMedium: {
    fontSize: 14,
    fontFamily: "Poppins",
    fontWeight: "400",
  },
  poppinsBold: {
    fontSize: 14,
    fontFamily: "Poppins",
    fontWeight: "700",
  },
  poppinsExtraSmallLight: {
    fontSize: 10,
    fontFamily: "Poppins",
    fontWeight: "300",
  },
  poppinsExtraSmallRegular: {
    fontSize: 10,
    fontFamily: "Poppins",
    fontWeight: "500",
  },
  poppinsSmallLight: {
    fontSize: 12,
    fontFamily: "Poppins",
    fontWeight: "300",
  },
  poppinsSmallRegular: {
    fontSize: 12,
    fontFamily: "Poppins",
    fontWeight: "500",
  },
  poppinsSmallBold: {
    fontSize: 12,
    fontFamily: "Poppins",
    fontWeight: "700",
  },
  poppinsExtraSmall: {
    fontSize: 10,
    fontFamily: "Poppins",
    fontWeight: "500",
  },
  poppinsLargeLight: {
    fontSize: 20,
    fontFamily: "Poppins",
    fontWeight: "300",
  },
  poppinsExtraLargeMedium: {
    fontSize: 22,
    fontFamily: "Poppins",
    fontWeight: "400",
  },
  ralewayExtraSmallSemibold: {
    fontSize: 10,
    fontFamily: "Raleway",
    fontWeight: "600",
  },
  ralewaySmallRegular: {
    fontSize: 12,
    fontFamily: "Raleway",
    fontWeight: "500",
  },
  ralewaySmallSemibold: {
    fontSize: 12,
    fontFamily: "Raleway",
    fontWeight: "600",
  },
  ralewayLargeLight: {
    fontSize: 22,
    fontFamily: "Raleway",
    fontWeight: "300",
  },
  ralewayExtraLargeMedium: {
    fontSize: 22,
    fontFamily: "Raleway",
    fontWeight: "400",
  },
  ralewayXXLargeMedium: {
    fontSize: 56,
    fontFamily: "Raleway",
    fontWeight: "400",
  },
  modalText: {
    fontSize: 18,
    fontWeight: "500",
    fontFamily: "Raleway",
  },
  tinyError: {
    fontSize: 9,
    fontWeight: "300",
    fontFamily: "Raleway",
  },
} as const;
